import cards4 from '../images/4cards.svg';
import cards8 from '../images/8cards.svg';
import cards16 from '../images/16cards.svg';
import { useState, useLayoutEffect } from 'react';
export const priceRows = [
    {
        image: cards4,
        number: 4,
        text: 'занятия',
        price: 7000,
    },
    {
        image: cards8,
        number: 8,
        text: 'занятий',
        price: 12000,
    },
    {
        image: cards16,
        number: 16,
        text: 'занятий',
        price: 22000,
    },
];

function useMedia(queries, values, defaultValue) {
    const [value, setValue] = useState(defaultValue);

    useLayoutEffect(() => {
        const mediaQueryLists = queries.map(q => window.matchMedia(q));
        const getValue = () => {
            const index = mediaQueryLists.findIndex(mql => mql.matches);
            return typeof values[index] !== 'undefined'
                ? values[index]
                : defaultValue;
        };
        const handler = () => setValue(getValue);

        handler();
        mediaQueryLists.forEach(mql => mql.addListener(handler));
        return () =>
            mediaQueryLists.forEach(mql => mql.removeListener(handler));
    }, []);

    return value;
}

export const useIsMobile = () => {
    return useMedia(['(max-width: 960px)'], [true], false);
};

export const Mobile = ({ children }) => {
    const isMobile = useIsMobile();
    return isMobile && children;
};

export const Desktop = ({ children }) => {
    const isDesktop = !useIsMobile();
    return isDesktop && children;
};
